import { useEffect, useRef, useState } from 'react';

export const useTimeChangeVariable = <T>(variable: T, time: number): [T | undefined] => {
    const [change, setChange] = useState(false);
    const timeId = useRef<number>();

    useEffect(() => {
        setChange(true);

        if (timeId.current) {
            window.clearTimeout(timeId.current);
        }

        timeId.current = window.setTimeout(setChange, time, false);
    }, [variable, time]);

    return [change ? variable : undefined];
};
